import { Card, message, Table } from "antd";
import API from "../../../../../services/api-request";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

const StorageCost = ({ idClient }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getStockData = async () => {
    setData([]);

    setLoading(true);
    API.Post(`dashboard/stocks?client_id=${idClient}`)
      .then((res) => {
        const page = 0;
        const limit = 5;

        const formatSelect = res?.data?.data?.stock?.map((item, index) => {
          return {
            ...item,
            no: page * limit + index + 1,
          };
        });

        formatSelect.sort((a, b) => b.received_at.localeCompare(a.received_at));

        setData(formatSelect.slice(0, 5));
      })
      .catch((err) => {
        setData([]);
        message.info(`${err?.response?.data?.error}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getStockData();
  }, []);

  const columns = [
    {
      title: "No.",
      key: "id",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Tipe Produk",
      dataIndex: "product_name",
      key: "product_name",
      render: (product_name) => {
        if (product_name === null || product_name === "-") {
          return "-";
        } else {
          return product_name;
        }
      },
    },
    {
      title: "Tanggal Inbound",
      dataIndex: "received_at",
      key: "received_at",
      render: (received_at) => {
        if (received_at === null || received_at === "-") {
          return "-";
        } else {
          return dayjs(received_at).format("DD-MM-YYYY");
        }
      },
    },
    {
      title: "Lama Penyimpanan",
      dataIndex: "duration",
      key: "duration",
      render: (duration) => {
        if (duration === null || duration === "-") {
          return "-";
        } else {
          return duration + " Hari";
        }
      },
    },
    {
      title: "Biaya",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => {
        if (amount === null || amount === "-") {
          return "-";
        } else {
          return "Rp " + amount.toLocaleString("id-ID");
        }
      },
    },
  ];

  return (
    <>
      <Card style={{ padding: 4 }}>
        <h3>Biaya Penyimpanan</h3>
        <Table
          rowKey={(dataSource) => dataSource.received_at}
          columns={columns}
          dataSource={data}
          pagination={{
            pageSize: 5,
            showSizeChanger: false,
          }}
          style={{ width: "100%" }}
          scroll={{ x: 600 }}
          loading={loading}
        />
      </Card>
    </>
  );
};

export default StorageCost;
